import L from "leaflet";
import icon from "./icons/drive_25.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

export const MarkerIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});
